import { atom } from "recoil";
import { TLang } from "stencil-library";

export const languageAtom = atom<TLang>({
  key: "language",
  default: localStorage.getItem("user_language") as TLang ?? "en",
});
